import puppyFemaleBrown from "../assets/images/puppyFace/puppyFemaleBrown.jpg"
import puppyFemaleOrange from "../assets/images/puppyFace/puppyFemaleOrange.jpg"

import puppyFemalePurple from "../assets/images/puppyFace/puppyFemalePurple.jpg"
import puppyFemalePurple2 from "../assets/images/puppyFace/puppyFemalePurple2.jpg"

import puppyFemaleWhite from "../assets/images/puppyFace/puppyFemaleWhite.jpg"
import FemalewithoutCollar from "../assets/images/puppyFace/puppyFemalewithoutCollar.jpg"
import puppyFemaleYellow from "../assets/images/puppyFace/puppyFemaleYellow.jpg"
import puppyFemaleLightGreen from "../assets/images/puppyFace/puppyFemaleLightGreen.jpg"

import puppyMaleBlack from "../assets/images/puppyFace/puppyMaleBlack.jpg"

import puppyMaleBlue from "../assets/images/puppyFace/puppyMaleBlue.jpg"
import puppyMaleGray from "../assets/images/puppyFace/puppyMaleGray.jpg"
import puppyMaleLightBlue from "../assets/images/puppyFace/puppyMaleLightBlue.jpg"
import puppyMalePink from "../assets/images/puppyFace/puppyMalePink.jpg"
import puppyMaleRed from "../assets/images/puppyFace/puppyMaleRed.jpg"

export const puppyList = [
    {
        name: "brown",
        birthday: "21/01/2021",
        sexe: "female",
        available: true,
        picture: puppyFemaleBrown,
        pictures: [
            {id:1, url: puppyFemaleBrown, alt: ""},
        ],
        id: 1
    },
    {
        name: "blue",
        birthday: "21/01/2021",
        sexe: "male",
        available: false,
        picture: puppyMaleBlue,
        pictures: [
            {id:1, url: puppyMaleBlue, alt: ""},
        ],
        id: 2
    },
    {
        name: "light Green",
        birthday: "21/01/2021",
        sexe: "female",
        available: true,
        picture: puppyFemaleLightGreen,
        pictures: [
            {id:1, url: puppyFemaleLightGreen, alt: ""},
        ],
        id: 3
    },
    {
        name: "yellow",
        birthday: "21/01/2021",
        sexe: "female",
        available: false,
        picture: puppyFemaleYellow,
        pictures: [
            {id:1, url: puppyFemaleYellow, alt: ""},
        ],
        id: 4
    },
    {
        name: "pink",
        birthday: "21/01/2021",
        sexe: "male",
        available: true,
        picture: puppyMalePink,
        pictures: [
            {id:1, url: puppyMalePink, alt: ""},
        ],
        id: 5
    },
    {
        name: "gray",
        birthday: "21/01/2021",
        sexe: "male",
        available: true,
        picture: puppyMaleGray,
        pictures: [
            {id:1, url: puppyMaleGray, alt: ""},
        ],
        id: 6
    },
    {
        name: "white",
        birthday: "21/01/2021",
        sexe: "female",
        available: true,
        picture: puppyFemaleWhite,
        pictures: [
            {id:1, url: puppyFemaleWhite, alt: ""},
        ],
        id: 7
    },
    {
        name: "light Blue",
        birthday: "21/01/2021",
        sexe: "male",
        available: true,
        picture: puppyMaleLightBlue,
        pictures: [
            {id:1, url: puppyMaleLightBlue, alt: ""},
        ],
        id: 8
    },
    {
        name: "orange",
        birthday: "21/01/2021",
        sexe: "female",
        available: true,
        picture: puppyFemaleOrange,
        pictures: [
            {id:1, url: puppyFemaleOrange, alt: ""},
        ],
        id: 9
    },
    {
        name: "purple",
        birthday: "21/01/2021",
        sexe: "female",
        available: true,
        picture: puppyFemalePurple,
        pictures: [
            {id:1, url: puppyFemalePurple, alt: ""},
            {id:2, url: puppyFemalePurple2, alt: ""},
        ],
        id: 10
    },
    {
        name: "black",
        birthday: "21/01/2021",
        sexe: "male",
        available: true,
        picture: puppyMaleBlack,
        pictures: [
            {id:1, url: puppyMaleBlack, alt: ""},
        ],
        id: 11
    },
    {
        name: "red",
        birthday: "21/01/2021",
        sexe: "male",
        available: true,
        picture: puppyMaleRed,
        pictures: [
            {id:1, url: puppyMaleRed, alt: ""},
        ],
        id: 12
    },
    {
        name: "without Collar",
        birthday: "21/01/2021",
        sexe: "female",
        available: true,
        picture: FemalewithoutCollar,
        pictures: [
            {id:1, url: "FemalewithoutCollar", alt: ""},
        ],
        id: 13
    }
]